'use strict';

(()=>{
	'use strict';

	if( $(window).width() > 740 ){

		// Rellax Parallax
		if( $('.rellax').length ){
			const rellax = new Rellax('.rellax', {
				speed: -2,
				center: true,
				round: true,
			    callback: (position)=> {
			      //TIP talvez colocar a logica de mostrar o menu da home com scroll aqui
			      // console.log(position);
			    }
			});
		}
	}


	// ScrollReveal
	window.sr = ScrollReveal({
		reset: false,
		afterReveal: (domEl)=> {
			// console.info(domEl)
			$(domEl).addClass('ready')

			if($(domEl).hasClass('home-testimonials-fx')){
				// $(domEL).addClass('class_name')
				$('.home-testimonials-fx .testimonial').eq(0).addClass('active');
			}
		}
	});

	if( $('body').hasClass('home') ){

		sr.reveal('.home-header-phone', { delay:300, duration: 2000, opacity: 0, origin:'bottom', distance: '200px', easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', mobile: false});
		sr.reveal('.home-header-title', { delay:700, duration: 700, opacity: 0, origin:'left', scale: '1', distance: '50px', easing: 'ease', mobile: false});
		sr.reveal('.home-btn-action', { delay:1000, duration: 700, opacity: 0, origin:'left', scale: '1', distance: '50px', easing: 'ease', mobile: false});

		sr.reveal('.home-seguranca-content-2 .balloon-info', { delay:500, duration: 1000, origin:'bottom', scale: '0.1', distance: '200px', easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', mobile: false});
		sr.reveal('.home-seguranca-content-2 h3', { delay:0, duration: 1200, origin:'bottom', distance: '100px', easing: 'ease', mobile: false});

		sr.reveal('.home-seguranca-phone', { delay:900, duration: 2000, opacity: 0, origin:'bottom', scale: '0.5', distance: '100px', easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', rotate: {x: 0, y: 0, z: 40 },mobile: false});
		// sr.reveal('.home-seguranca-phone video', { delay:500, duration: 1000, easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', mobile: false});

		sr.reveal('.home-transfer-phone', { delay:0, duration: 1000, opacity: 0, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', rotate: {x: 0, y: 0, z: 30 }, mobile: false});
		sr.reveal('.home-transfer-phone-qr', { delay:300, duration: 1000, opacity: 0, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', rotate: {x: 0, y: 0, z: -30 }, mobile: false});

		sr.reveal('.home-transfer-phone .icons div', { delay:700, duration: 600, opacity: 0, scale: '0.1', easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', rotate: {x: 0, y: 0, z: 120 }, mobile: false}, 200);

		sr.reveal('.home-familia-phone', { delay:0, duration: 1000, opacity: 0, origin:'left', distance: '300px',  easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', rotate: {x: 0, y: 0, z: 30 },mobile: false});
		sr.reveal('.home-familia-phone-balloon', { delay:250, duration: 1400, origin:'bottom', scale: '0.1', distance: '50px', easing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)', mobile: false});

		sr.reveal('.home-cloud-phon', { delay:100, duration: 1500, opacity: 0, easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', rotate: {x: 0, y: 0, z: -20 }, mobile: false});
		sr.reveal('.home-cloud-phone-photos img', { delay:600, duration: 1000, origin:'top', distance: '10px', easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', mobile: false}, 30);


		sr.reveal('.cloud-phone-photos img', { delay:600, duration: 1000, origin:'top', distance: '10px', easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', mobile: false}, 30);

		sr.reveal('.home-wifi-phone', { delay:0, duration: 1000, opacity: 0, origin:'right', distance: '300px',  easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', rotate: {x: 0, y: 0, z: 30 },mobile: false});
		sr.reveal('.home-wifi-phone-io', { delay:700, duration: 600, scale: '0.7', easing: 'cubic-bezier(0.495, 0.285, 0.115, 1.000)', mobile: false});

		sr.reveal('.home-help-desk-content-1 .chat .one', { delay:100, duration: 600, origin:'left', distance: '100px', easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)', mobile: false});
		sr.reveal('.home-help-desk-content-1 .chat .two', { delay:500, duration: 600, origin:'right', distance: '100px', easing: 'ease', mobile: false});
		sr.reveal('.home-help-desk-content-1 .chat .three', { delay:900, duration: 600, origin:'left', distance: '100px', easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)', mobile: false});
		sr.reveal('.home-help-desk-content-1 .chat .four', { delay:1400, duration: 600, origin:'right', distance: '100px', easing: 'ease', mobile: false});

		sr.reveal('.home-testimonials-fx', { delay:0, duration: 900, scale: '0.7', easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', mobile: false});

	}
})();
